import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => {
return ({
	rootGrid: {
			flexGrow: 1,
	},
	itemGrid: {
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	rootCard: {
		position: 'relative',
		margin: 0,
		width: '100%',
		height: prop => prop.contentMediaTable ? 80 : 130,
		border: "2px outset grey",
		'@media (max-width:998px)':{
			height:120,
		},
		'@media (max-width:876px)':{
			height:110,
		},
		'@media (max-width:768px)':{
			display: prop => prop.showInMovil ? 'block' : 'none',
			marginRight: '0px',
			width: '100%',
		},
		'&:hover' : {
			opacity: .9,
		},
		'&:hover button' : {
			display: 'block',
		},
	},
	contentMedia:{
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	contentMediaTable:{
		width: 85,
		height: 85,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	media: {
		width: 150,
		height:130,
		'@media (max-width:1200px)':{
			width: 130,
			height:130,
		},
		'@media (max-width:998px)':{
			maxWidth: 110,
			height:120,
		},
		'@media (max-width:876px)':{
			maxWidth: 110,
			height:110,
		},
	},
	marginBottom: {
		marginBottom: '20px',
	},
	cardContent: {
		padding: '5px',
		maxWidth: 250,
	},
	cardButtons: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	centerTitle: {
		textAlign: 'center',
		fontSize: '18px',
		textTransform: 'uppercase',
		backgroundColor:'gainsboro',
		color: 'black',
	},
	centerTitle2: {
		textAlign: 'center',
		fontSize: '16px',
		textTransform: 'uppercase',
		backgroundColor:'gainsboro',
		color: 'black',
	},
	centerTitleVer: {
		textAlign: 'center',
		fontSize: '14px',
		textTransform: 'uppercase',
		backgroundColor:'gainsboro',
		color: 'black',
		margin: 0,
		border: "2px outset grey",
		borderRadius: 5,
		'@media (max-width:768px)':{
			display: 'none',
		},
		"&:hover": {
			cursor: 'pointer'
		}
	},
	centerText: {
		textAlign: 'center',
		fontSize: '18px',
		textTransform: 'uppercase',
		margin: '20px 0px',
	},
	iconVisibility: {
		display: 'none',
		background: '#205690',
		color: '#fff',
		position:"absolute",
		top:'30%',
		left:'30%',
		opacity: 1,
		'@media (max-width:998px)':{
			top:'25%',
			left:'25%',
		},
		'&:hover' : {
			background: '#205690',
			color: '#fff',
		},
	},
	button:{
		marginTop: 5,
		"background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)",
		"border":"0px", "borderRadius":"3",
		"boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white",
		width: '100%',
		marginRight: 15,
		marginBottom: 10,
		textAlign: 'center',
		fontSize: '12px',
		'@media (max-width:768px)':{
			width: '100%',
		},
	},
	observacion: {
		textAlign: 'center',
		marginTop: prop => prop.showButtonEditDocument ? '0' : '10px',
		fontSize: '14px',
		textTransform: 'uppercase',
		backgroundColor:'gainsboro',
		color: 'black',
	},
	imagen: {
		display: "block",
		margin: "0 auto"
	},
	parent: {
		display: "flex",
		justifyContent: "center",
		alignItems: 'center',
		textAlign: 'center'
	}
})
});
